import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const SummaryCard = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: none;
    border-radius: 6px;
    padding: 15px 15px;
    margin-bottom: 10px;
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    ${media.mobileDevice`
    border: 1px solid #74DED6;
    margin-bottom: 7px;    
    `}
`;

export const SummaryHeading = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #140f4b;
    font-size: 16px;
    padding-bottom: 0.5rem;
    ${media.mobileDevice`
    font-size: 15px;
    line-height:27px;
    color:#140F4B
    `}
`;

export const OuterLayout = styled.span``;
export const Layout = styled.div`
    background: #f5f5f5cc 0% 0% no-repeat padding-box;
    display: flex;
    align-items: center;
    padding: 5px 0;
    ${media.mobileDevice`
        align-items: ${({ alignItems }) => (alignItems)};
        padding: 0;
    `}
`;

export const AwaitingApproval = styled.span`
    color: #4f4f4f;
    font-family: AvenirNextWorld Demi;
    text-align: left;
    opacity: 1;
    font-size: 13px;
    text-transform: capitalize;
    ${media.mobileDevice`
        font-size: 12px;
        line-height:20px;

    `}
`;
export const Pending = styled.span`
    color: #ed002a;
    text-align: right;
    float: right;
    font-family: AvenirNextWorld Demi;
    padding: 0rem 1rem;
    font-size: 14px;
    text-transform: capitalize;
    line-height: 24px;
    ${media.mobileDevice`
         padding: 0rem 0.5rem;
    `}
`;
export const Account = styled.div`
    width: 50%;
    height: 100%;
    color: #202124;
    opacity: 1;
    padding: ${({ padding }) => (padding ? padding : '0.5rem 1rem')};
    ${media.mobileDevice`
    width: 100%;
    `}
`;

export const InnerLayout = styled.div`
    display: flex;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const SummaryContent = styled.div`
    display: inline-block;
    width: 100%;
    padding-bottom: 0.5rem;
    text-align: ${({ textAlign }) => textAlign};
`;

export const TissueServices = styled.span`
    font-family: AvenirNextWorld Regular;
    font-size: 13px;
    float: ${({ float }) => (float ? float : 'left')};
    color: ${({ color }) => (color ? color : '#4F4F4F')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
`;

export const TissueNo = styled.span`
    float: right;
    color: ${({ color }) => (color ? color : '#4F4F4F')};
    font-family: AvenirNextWorld Regular;
    font-size: 13px;
    ${media.mobileDevice`
    font-size: 15px;
    line-height: 23px;
    `}
`;

export const Title = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
`;

export const Data = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #202124;
    font-size: 15px;
`;

export const TissueServicesTotal = styled.span`
    font-family: AvenirNextWorld Demi;
    color: #4f4f4f;
    font-size: 16px;
`;
export const ApprovalContainer = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    padding: 0.5rem 1rem;
    ${media.mobileDevice`
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
    `}
`;
